import {
    ReactNode,
    createContext,
    useCallback,
    useMemo,
    useState,
} from 'react';
import {
    QuestionChoices,
    ScreeningResultsScores,
    StandaloneResultsValues,
} from './types';

export const StandaloneResultsValuesContext =
    createContext<StandaloneResultsValues>(undefined!);

type Props = { children: ReactNode };

export function StandaloneResultsValuesProvider({ children }: Props) {
    const [scores, setScores] = useState<ScreeningResultsScores | undefined>(
        undefined
    );
    const [questionChoices, setQuestionChoices] = useState<
        QuestionChoices | undefined
    >(undefined);

    const clearValues = useCallback(() => {
        setScores(undefined);
        setQuestionChoices(undefined);
    }, [setScores, setQuestionChoices]);

    const [hasAcceptedChdpp, setHasAcceptedChdpp] = useState(false);

    const value = useMemo(
        () =>
            ({
                scores,
                questionChoices,
                setScores,
                setQuestionChoices,
                clearValues,
                hasCompletedScreening: !!scores,
                hasAcceptedChdpp,
                setHasAcceptedChdpp,
            } as StandaloneResultsValues),
        [
            scores,
            questionChoices,
            clearValues,
            hasAcceptedChdpp,
            setHasAcceptedChdpp,
        ]
    );
    return (
        <StandaloneResultsValuesContext.Provider value={value}>
            {children}
        </StandaloneResultsValuesContext.Provider>
    );
}
